import CardOnFile from '@liveauctioneers/caterwaul-components/lib/CardOnFile/CardOnFile';
import { CreditCard } from '@liveauctioneers/caterwaul-components/lib/types/CreditCard';
import { Radio } from '@liveauctioneers/hammer-ui-core/radio';
import React, { useEffect, useMemo, useState } from 'react';

import { usePrevious } from '@/hooks/usePrevious';

type Props = {
    creditCards: CreditCard[];
    deleteCard?: (cardId: number) => void;
    selectCard: (creditCard: CreditCard) => void;
};

const PaymentMethodSelection = ({ creditCards, deleteCard, selectCard }: Props) => {
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<string>();
    const previousNumberOfCards = usePrevious(creditCards?.length);

    useEffect(() => {
        if (Boolean(creditCards) && (!selectedPaymentMethodId || previousNumberOfCards !== creditCards?.length)) {
            const defaultCardOnFile = creditCards.find((cof) => cof.defaultCard);
            setSelectedPaymentMethodId(`card-${defaultCardOnFile?.id}`);
            if (defaultCardOnFile && selectCard) {
                selectCard(defaultCardOnFile);
            }
        }
    }, [creditCards, previousNumberOfCards, selectCard, selectedPaymentMethodId]);

    const creditCardRadios = useMemo(() => {
        if (!creditCards) {
            return null;
        }
        const sortedcreditCards = creditCards.sort((cardA, cardB) => {
            return new Date(cardB.created).getTime() - new Date(cardA.created).getTime();
        });
        return sortedcreditCards.map((creditCard) => {
            const radioId = `card-${creditCard.id}`;
            const selected = selectedPaymentMethodId === radioId;
            return (
                <Radio.Option
                    checked={selected}
                    className="mb-md w-full items-start pl-md pt-xs [&_input]:mt-[36px]"
                    key={creditCard.id}
                    name="creditCard"
                    onChange={() => {
                        setSelectedPaymentMethodId(radioId);
                        selectCard(creditCard);
                    }}
                    value={radioId}
                >
                    <div>
                        <CardOnFile
                            creditCard={creditCard}
                            deleteCard={
                                deleteCard
                                    ? (event) => {
                                          event.stopPropagation();
                                          if (selected) {
                                              setSelectedPaymentMethodId(undefined);
                                          }
                                          deleteCard(creditCard.id);
                                      }
                                    : undefined
                            }
                            deleteCardLinkText="Remove"
                            isDefault={creditCard.defaultCard}
                            isRadio
                        />
                    </div>
                </Radio.Option>
            );
        });
    }, [creditCards, selectedPaymentMethodId, deleteCard, selectCard]);

    return <div>{creditCardRadios}</div>;
};

export default PaymentMethodSelection;
